// 首页接口
import request from './http'
import {emptyToNull} from "@/utils";

// 拉最新消息(全部)
export function getNewsList(data) {
  let params = emptyToNull({ ...data })
  return request('/api/v1/expose/listSubRTexts', params, 'post', true)
}
// 拉最新消息（分类）
export function getNewsListByTab(data) {
  let params = emptyToNull({ ...data })
  return request('/api/v1/expose/getRichTextList', params, 'post', true)
}
// 获取card列表
export function getCardList(data) {
  let params = emptyToNull({ ...data })
  return request('/api/v1/expose/getBannerList', params, 'post', true)
}

// 通过id拉取详情
export function getDetailById(data) {
  let params = {}
  return request('/api/v1/expose/getRichTextById/' + data, params, 'get', true)
}

// 通过id拉banner
export function getBannerById(data) {
  let params = emptyToNull({ ...data })
  return request('/api/v1/expose/getBannerList', params, 'post', true)
}
